import { render } from "./CxGridPopup.vue?vue&type=template&id=dc59e168&scoped=true"
import script from "./CxGridPopup.vue?vue&type=script&lang=js"
export * from "./CxGridPopup.vue?vue&type=script&lang=js"

import "./CxGridPopup.vue?vue&type=style&index=0&id=dc59e168&lang=less&scoped=true"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc59e168"]])

export default __exports__